var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { useCallback } from 'react';
import { ComposerAnalyticsEvent, } from '../types/component';
/**
 * Canonical Amplitude event names for the shared EventComposer's abstract
 * analytics events. Kept in one place so every hosting app reports the same
 * names.
 */
export var composerAmplitudeEventNames = (_a = {},
    _a[ComposerAnalyticsEvent.COMPOSER_OPENED] = 'opened-event-composer',
    _a[ComposerAnalyticsEvent.EVENT_CREATED] = 'created-event',
    _a[ComposerAnalyticsEvent.EVENT_UPDATED] = 'updated-event',
    _a[ComposerAnalyticsEvent.EVENT_SYNC_FAILED] = 'failed-event-sync',
    _a[ComposerAnalyticsEvent.COMPOSER_ABANDONED] = 'abandoned-event-composer',
    _a[ComposerAnalyticsEvent.OPENED_ADD_SPACE_SIDER] = 'opened-add-space-sider',
    _a[ComposerAnalyticsEvent.ADDED_SPACE] = 'added-space-to-event',
    _a[ComposerAnalyticsEvent.ADDED_SUGGESTED_SPACE] = 'added-suggested-space-to-event',
    _a[ComposerAnalyticsEvent.OPENED_SUGGESTED_TIMES_SIDER] = 'opened-suggested-times-sider',
    _a[ComposerAnalyticsEvent.SELECTED_SUGGESTED_TIME] = 'selected-suggested-time',
    _a[ComposerAnalyticsEvent.SELECTED_RECURRENCE] = 'selected-recurrence',
    _a[ComposerAnalyticsEvent.ADDED_EXTERNAL_INVITEE] = 'added-external-invitee',
    _a[ComposerAnalyticsEvent.EVENT_CANCELED] = 'canceled-event',
    // Intentionally shares its name with schedule's legacy week-schedule event;
    // the `source: 'event-composer'` property distinguishes the surfaces while
    // keeping one metric for "space removed from event".
    _a[ComposerAnalyticsEvent.REMOVED_SPACE] = 'removed-space-from-event',
    _a);
/**
 * Stamped onto every composer event's metadata so composer-originated events
 * are unambiguously filterable in Amplitude — even when an event name is
 * shared with another surface (e.g. `removed-space-from-event`) or when two
 * hosts report the same `entryPoint` (shell-over-office vs office's own
 * renderer).
 */
export var COMPOSER_EVENT_SOURCE = 'event-composer';
/**
 * Builds the `onTrackComposerEvent` callback for `EventComposer`: maps the
 * composer's abstract `ComposerAnalyticsEvent` types to the canonical
 * Amplitude names and stamps `source` + the host's `entryPoint` onto the
 * metadata.
 */
export var useTrackComposerEvent = function (_a) {
    var trackEvent = _a.trackEvent, entryPoint = _a.entryPoint;
    return useCallback(function (eventType, metadata) {
        trackEvent(composerAmplitudeEventNames[eventType], __assign({ source: COMPOSER_EVENT_SOURCE, entryPoint: entryPoint, page_url: typeof window !== 'undefined' ? window.location.href : undefined, page_path: typeof window !== 'undefined' ? window.location.pathname : undefined }, metadata));
    }, [trackEvent, entryPoint]);
};
